{
  "pending": "En attente",
  "delivered": "Délivré",
  "retry": "Réessai",
  "error": "En erreur",
  "cancelling": "Annulation",
  "cancelled": "Annulé",
  "paused": "En pause",
  "done": "Terminé",
  "running": "En cours",
  "expired": "Expirée",
  "dateFormat": "DD/MM/YYYY à HH:mm",
  "operationType": {
    "CRTCLT_RENEWAL_DVC": "Renouvellement de certificat",
    "CRTCLT_RENEWAL_APP": "Renouvellement de certificat",
    "FIRMWARE_UPGRADE_DVC": "Mise à jour du firmware"
  },
  "type": "Type d'opération",
  "createdAt": "Date de création",
  "launchedAt": "Date de lancement prévue",
  "updatedAt": "Date de modification",
  "state": "Statut de l'opération",
  "certificate": {
    "update": {
      "label": "Renouvellement de certificat",
      "dateTimeError": "Le champ date est requis pour la mise à jour du certificat",
      "plannedStartAt": {
        "label": "Configuration de l’opération",
        "placeholder": "Séléctionnez une date"
      },
      "dateNotValidAfterRenewal": "La date doit être valide avant l'expiration du certificat"
    }
  },
  "firmware": {
    "update": {
      "label": "Mise à jour du firmware",
      "description": "Paramétrer la date et l'heure de la procédure de lancement de la mise à jour du firmware de l'{name}",
      "firmwareLabel": "Firmware",
      "uuidRequired": "Le firmware est obligatoire",
      "plannedStartAt": "Date de mise à jour du firmware (JJ/MM/AAAA HH:MM)",
      "notaBene": "La mise à jour du firmware sera effectuée lors de la prochaine communication avec l'{name} à partir de la date de mise à jour du firmware.",
      "dateTimeError": "Le champ date est requis pour la mise à jour du firmware",
      "warningMessage": "Attention: La mise à jour du firmware entraînera un redémarrage de l'équipement à la fin de la mise à jour.",
      "version": "Version",
      "dtwin": {
        "description": "Paramétrez la configuration de l’opération de mise à jour de firmware.",
        "launchPlannedAt": "Date de mise à jour",
        "validation": {
          "launchPlannedAt": "La date de mise à jour est obligatoire."
        },
        "startsAtCreation": "Transmission de l’opération à l’équipement dès que possible",
        "firmware": "Sélectionnez un firmware dans la liste ci-dessous"
      },
      "scheduled": {
        "warningMessage": "L’équipement a déjà une opération du même type planifiée, en attente ou en cours"
      }
    }
  },
  "dateInferiorToToday": "La date ne doit pas être inférieure à la date/heure actuelle",
  "empty": "Aucune opération trouvée",
  "actions": "Actions",
  "queued": "En file d'attente",
  "failed": "Échoué",
  "unknown": "Statut inconnu",
  "scheduled": "Planifié",
  "configuration": {
    "selfSupportingVersion": "Version auto-portante",
    "globalVersion": "Version globale",
    "specificVersion": "Version spécifique",
    "updatedDate": "Date de modification"
  },
  "unitary": {
    "title": "Unitaire"
  },
  "campaign": {
    "title": "Campagne"
  },
  "trigger": {
    "title": "Déclenchement",
    "AUTO": "Automatique",
    "MANUAL": "Manuel"
  },
  "on_hold": "En attente"
}
